module.exports = __webpack_public_path__ + "static/img/easy-icon.fcdbe4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/easy-icon.png
// module id = 3kZn
// module chunks = 1